<template>
  <div class="product-category">
    <a-card>
      <!-- 查询区 -->
      <div class="search-bar">
        <a-form>
          <a-row :gutter="8">
            <a-col :span="6">
              <a-form-item label="产品品类名称" :labelCol="{ flex: '100px' }" :wrapperCol="{ flex: 'auto' }">
                <a-input placeholder="请输入产品品类名称" style="width: 100%" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item>
                <a-button type="primary" style="margin-right: 8px;">查询</a-button>
                <a-button>重置</a-button>
              </a-form-item>
            </a-col>
          </a-row>

        </a-form>
        <!-- 根节点提示和右侧按钮 -->
        <div class="root-bar">
          <div class="root-tip">根节点：全部产品品类</div>
          <div class="search-bar-extra">
            <a-button type="link">新增</a-button>
            <a-button type="link">物模型</a-button>
          </div>
        </div>
      </div>
      <!-- 表格区 -->
      <a-table :columns="columns" :data-source="dataSource" :pagination="false" rowKey="id">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'image'">
            <a-image :width="48" :height="48" :preview="false" src="https://img.icons8.com/ios/100/000000/image.png" />
          </template>
          <template v-else-if="column.key === 'action'">
            <a @click="() => {}" style="color:#1677ff; margin-right:8px;">新增</a>
            <a @click="() => goDetail(record)" style="color:#1677ff; margin-right:8px;">详情</a>
            <a @click="() => {}" style="color:#ff4d4f;">删除</a>
          </template>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script setup lang="ts">
import { useRouter, useRoute } from 'vue-router'
import { watch } from 'vue'
import { ref } from 'vue'

const router = useRouter()
const route = useRoute()

const columns = [
  { title: '产品品类名称', dataIndex: 'name', key: 'name' },
  { title: '产品品类描述', dataIndex: 'desc', key: 'desc' },
  { title: '图片', dataIndex: 'image', key: 'image' },
  { title: '操作', key: 'action' }
]
const dataSource = [
  { id: 1, name: '传感器设备', desc: '', image: '' },
  { id: 2, name: '照明设备', desc: '', image: '' },
  { id: 3, name: '空调设备', desc: '', image: '' },
  { id: 4, name: '风扇设备', desc: '', image: '' }
]

const handleAdd = () => {
  router.push('/network/device-mgr')
}

function onSelectSideMenu(keys: string[]) {
  if (keys[0] === 'device-mgr') router.push('/network/device-mgr')
  else if (keys[0] === 'product-mgr') router.push('/network/product-mgr')
  // ...其它菜单
}

const topKeyMap = [
  { key: 'dashboard', path: '/' },
  { key: 'network', path: '/network/overview' },
  { key: 'system', path: '/system' },
  { key: 'lowcode', path: '/lowcode' },
  { key: 'profile', path: '/profile' }
]

const selectedTopKeys = ref(['dashboard'])

watch(
  () => route.path,
  (path) => {
    if (path === '/' || path === '') selectedTopKeys.value = ['dashboard']
    else if (path.startsWith('/network')) selectedTopKeys.value = ['network']
    else if (path.startsWith('/system')) selectedTopKeys.value = ['system']
    else if (path.startsWith('/lowcode')) selectedTopKeys.value = ['lowcode']
    else if (path.startsWith('/profile')) selectedTopKeys.value = ['profile']
    else selectedTopKeys.value = ['dashboard']
  },
  { immediate: true }
)

function onTopMenuClick({ key }: { key: string }) {
  if (key === 'dashboard') router.push('/')
  else if (key === 'network') router.push('/network/overview')
  else if (key === 'system') router.push('/system')
  else if (key === 'lowcode') router.push('/lowcode')
  else if (key === 'profile') router.push('/profile')
}

const selectedSideKeys = ref(['overview'])
const openKeys = ref(['access', 'ops'])

watch(
  () => route.path,
  (path) => {
    // 侧边栏高亮
    if (path === '/network/overview') selectedSideKeys.value = ['overview']
    else if (path === '/network/device-mgr') {
      selectedSideKeys.value = ['device-mgr']
      openKeys.value = ['access']
    }
    else if (path === '/network/model') {
      selectedSideKeys.value = ['model']
      openKeys.value = ['access']
    }
    else if (path === '/network/product-mgr') {
      selectedSideKeys.value = ['product-mgr']
      openKeys.value = ['access']
    }
    else if (path === '/network/product-cat') {
      selectedSideKeys.value = ['product-cat']
      openKeys.value = ['access']
    }
    else if (path === '/network/ota') {
      selectedSideKeys.value = ['ota']
      openKeys.value = ['ops']
    }
    // ...其它菜单
  },
  { immediate: true }
)

function goDetail(record: any) {
  router.push(`/network/product-cat/${record.id}`)
}
</script>

<style lang="less" scoped>
.product-category {
  .search-bar {
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    .search-bar-extra {
      margin-left: auto;
      display: flex;
      gap: 8px;
    }
  }
  .root-bar {
    display: flex;
    margin-top: 16px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }
  .root-tip {
    font-weight: bold;
  }
}
</style> 